<template>
  <div class="canvassDetailPage">
    <XR-head titleText="招商加盟" :rightShow="false"></XR-head>    
    <div class="tj-detail-news">
			<h1 class="title">{{articleEntity.ArticleTitle}}</h1>
			<p class="date">{{articleEntity.UpdateDateName}}</p>
			<div class="content">
        <span v-html="articleEntity.ArticleContext"></span>
      </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data(){
    return {      
      dialog: false,
      loaded: true,
      articleEntity:{},
      queryInfo:{
        Id: this.$route.query.id
      }
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getArticleDetail()
    this.UpdateReadingQuantity()
  },
  methods:{
    getArticleDetail(){
      var ths = this;   
      ths.$post(
        "/Shop/ArticleServer/GetHealthyAricleDetial",
        JSON.stringify(this.queryInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.loaded=false   
          ths.articleEntity = res.Data
          ths.$refs.XRtoast.hide()
        }
      });
    },    
    UpdateReadingQuantity(){
      var ths = this;   
      ths.$post(
        "/Shop/ArticleServer/GetHealthyAricleDetial",
        JSON.stringify(this.queryInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.loaded=false   
          ths.articleEntity = res.Data
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
}
</script>

<style>
.canvassDetailPage{
  background: white;
  overflow-x: hidden;
  overflow-y: scroll;
}

.canvassDetailPage .tj-detail-news{
  padding:.625rem;
}
.canvassDetailPage .tj-detail-news h1.title{
  font-size: 1.25rem;
  line-height: 1.625rem;
  padding-left: 2px;
  color: #232323;
}
.canvassDetailPage .tj-detail-news p.date{
  font-size: .75rem;
  line-height: 1.75rem;
  padding:.375rem 0 .5rem;
  color:#959595;
}
.canvassDetailPage .tj-detail-news div.content{
  width:100%;
  overflow:hidden;
  line-height: 1.25rem;
  font-size: 12px;
  color: #222;
}
.canvassDetailPage .tj-detail-news div.content img{
  display: block;
  margin:0 auto;
  width:100%;	
}
.canvassDetailPage .tj-detail-news div.content p{
  padding:3px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/canvassDetail.vue